export enum SETTINGS_MENU {
    /**
     * @value Content strategy
     */
    CONTENT_STRATEGY = 'ADMIN.NAV.SUB_CONTENT_STRATEGY',
    /**
     * @value Navigation
     * @description Title of the mobile navigation administration
     */
    NAVIGATION = 'ADMIN.MOBILE.NAVIGATION.TITLE',
    /**
     * @value Site
     */
    SUB_INSTANCE = 'ADMIN.NAV.SUB_INSTANCE',
    /**
     * @value Modules
     */
    SUB_MODULES = 'ADMIN.NAV.SUB_MODULES',
}
